import type { BlogPost } from "./types";

// Image guidance from source doc (photo omitted for now; add to public/blog/ later):
//  *   Legal scales icon over digital/tech background representing accessibility law enforcement — alt: "Legal scales of justice overlaid on a digital interface background representing the enforcement of the Rights of Persons with Disabilities Act 2016 in India"
//  *   CCPD online complaint portal for persons with disabilities in India — alt: "Screenshot of the CCPD Court Portal (ccpdcourt.gov.in) showing the complaint filing interface for persons with disabilities in India"
const post: BlogPost = {
  slug: "rpwd-act-digital-accessibility-enforcement-india-2025",
  title: "The RPwD Act and Digital Accessibility in India",
  metaTitle: "RPwD Act Digital Accessibility Enforcement",
  subtitle:
    "The CCPD began fining non-compliant establishments in 2025. What the RPwD Act requires of digital services and how to build a defensible position.",
  date: "2026-07-19",
  photo: "/blog/rpwd-act-digital-accessibility-enforcement-india-2025.svg",
  alt:
    "Legal scales of justice overlaid on a digital interface background representing the enforcement of the Rights of Persons with Disabilities Act 2016 in India",
  author: "AccessBharat",
  tag: "India",
  excerpt:
    "The CCPD began fining non-compliant establishments in 2025. What the RPwD Act requires of digital services and how to build a defensible position.",
  body: `For years the Rights of Persons with Disabilities Act 2016 was treated as framework legislation: important in principle, rarely enforced. That changed in early 2025. The Chief Commissioner for Persons with Disabilities (CCPD) has started fining establishments that do not comply, an auditor ecosystem has been formalised, and the complaint portal is producing case orders every month. India's accessibility law now has consequences.

## What the law requires

Section 46 of the RPwD Act 2016 requires that content in audio, print and electronic media be available in accessible formats. This is not limited to government bodies. The Act applies broadly to establishments that receive government funding, educational institutions and any entity that provides services to the public. In practice, your website, mobile app and digital content need to be usable by people with disabilities.

## Enforcement is happening

In February 2025, the CCPD issued a formal letter imposing fines on establishments that had not filed Access Audit Reports or engaged an empanelled auditor. The same month, the DEPwD published an official list of empanelled web accessibility auditors, the infrastructure needed to make mandatory audits workable.

The CCPD publishes orders every month across employment, reasonable accommodation and accessibility complaints. Its suo-motu track also lets it act without a formal complaint from an individual.

Waiting for a complaint before acting is no longer a safe approach.

## What compliance looks like

The practical benchmark for digital accessibility in India is the GIGW 3.0 standard (WCAG 2.1 Level AA). An Access Audit Report from an empanelled or IAAP-certified auditor is increasingly the document you are asked for. The minimum steps are to:

1. engage a qualified auditor
2. document where you currently fall short
3. start fixing the high-priority issues
4. publish an accessibility statement

## Beyond the legal risk

India has roughly 26.8 million persons with disabilities according to the 2011 Census, a figure widely considered an undercount. The number of people who rely on accessible digital interfaces is higher still once you include older users and people with temporary or situational impairments. Excluding them is a legal risk and also means turning away customers.
`,
};

export default post;
